<style lang="scss" scoped>
.register {
    padding: 0 20px;
    width: 380px;
    box-shadow: 0 0 2px #fff;
    background-color: rgba(255, 255, 255, 0.3);
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    .head {
        text-align: center;
        font-size: 24px;
        padding: 20px 0;
        span {
            font-size: 16px;
        }
        .ohterTip {
            position: relative;
            font-size: 14px;
            margin-top: 10px;
            padding: 2px 24px;
            color: #FF0000;
            border: 1px solid #FF0000;
            .close {
                position: absolute;
                top: 0;
                cursor: pointer;
                right: 0;
            }
        }
    }
    .asinkingTerm {
            padding: 0 2px;
            font-size: 14px !important;
            height: 16px;
            line-height: 16px;
            border: none;
            background: transparent;
            color: #006eff;
    }
    .submitApply {
        margin-top: 10px;
        padding-bottom: 20px;
        text-align: right;
    }
    &-title {
        position: relative;
    }
    &-content {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        height: 100%;
        min-height: 100vh;
    }
    &-icon {
        position: absolute;
        cursor: pointer;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
    }
    &-bg {
        background: url("../image/bg.jpg") no-repeat center center/cover;
        // position: absolute;
        // top: 0;
        // left: 0;
        // right: 0;
        // bottom: 0;
        overflow-y: auto;
        height: 100%;
    }
    .ivu-checkbox-wrapper {
        display: flex;
        align-items: center;
    }
    /deep/.ivu-checkbox {
        margin-right: 5px;
    }
}
.read {
    .doc {
        padding: 0;
        p{
            text-indent: 24px;
            line-height: 20px;
            margin: 12px 0;
        }
        .strong-underline {
            font-weight: bold;
            text-decoration: underline;
        }
        .no-indent {
            text-indent: 0;
        }
        .one-level-indent {
            text-indent: 24px;
        }
        ul{
            list-style: none;
            padding-left: 40px;
            li{
                line-height: 30px;
            }
        }
        h2, h3 {
            text-indent: 24px;
            padding: 15px 0;
        }
    }
    /deep/.ivu-modal-footer {
            text-align: center;
        }
    /deep/.ivu-modal {
        top: 0;
        position: relative;
    }
    /deep/.ivu-modal-content {
        display: flex;
        flex-direction: column;
        -webkit-box-shadow: none;
        box-shadow: none;
        position: relative;
        margin: 4.6vh auto;
        background: #fff;
        border-radius: 2px;
        box-sizing: border-box;
        height: 90.7vh;
    }
    /deep/.ivu-modal-body {
        flex: 1;
        padding: 20px 24px 0;
        color: #000;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        word-break: break-all;
        outline: none;
    }
}
</style>

<template>
    <div class="register-bg">
        <div class="register-content">
            <div class="register">
                <div class="head">
                    <p class="register-title">
                        <Icon @click="backToLogin" class="register-icon" type="md-arrow-back" />
                        Bizark BOSS
                    </p>
                    <span>提交账户注册申请</span>
                    <div class="ohterTip" v-show="ohterTip">
                        {{ohterText}}
                        <Icon @click="ohterTip=false" type="ios-close close" size="24"/>
                    </div>
                </div>
                <Form :model="formData" :label-width="0" :rules="rules" ref="register">
                    <FormItem prop="userName">
                        <Input v-model="formData.userName" placeholder="姓名">
                            <Icon type="ios-contact" slot="prefix" />
                        </Input>
                    </FormItem>
                    <FormItem prop="userLoginEmail">
                        <Input v-model="formData.userLoginEmail" placeholder="邮箱" @on-blur="check">
                            <Icon type="ios-mail-outline" slot="prefix" />
                        </Input>
                    </FormItem>
                    <FormItem prop="userLoginPhone">
                        <Input v-model="formData.userLoginPhone" placeholder="手机号" @on-blur="check">
                            <Icon type="ios-call-outline" slot="prefix" />
                        </Input>
                    </FormItem>
                    <FormItem prop="userPassword">
                        <Input v-model="formData.userPassword" type="password" placeholder="密码">
                            <Icon type="md-lock" slot="prefix" />
                        </Input>
                    </FormItem>
                    <FormItem prop="repassword">
                        <Input v-model="formData.repassword" type="password" placeholder="确认密码">
                            <Icon type="md-lock" slot="prefix" />
                        </Input>
                    </FormItem>
                    <FormItem prop="companyName">
                        <Input v-model="formData.companyName" placeholder="组织名称" @on-blur="check">
                            <Icon type="ios-people-outline" slot="prefix" />
                        </Input>
                    </FormItem>
                    <FormItem prop="companyAddress">
                        <Input v-model="formData.companyAddress" placeholder="公司地址">
                            <Icon type="ios-information-circle-outline" slot="prefix" />
                        </Input>
                    </FormItem>
                    <!-- <FormItem prop="contactName">
                        <Input v-model="formData.contactName" placeholder="联系人">
                            <Icon type="ios-mail-outline" slot="prefix" />
                        </Input>
                    </FormItem> -->
                    <!-- <FormItem prop="contactTel">
                        <Input v-model="formData.contactTel" placeholder="联系电话">
                            <Icon type="ios-mail-outline" slot="prefix" />
                        </Input>
                    </FormItem> -->
                    <FormItem prop="extraInfo.dailyOrderAvg">
                        <Select v-model="formData.extraInfo.dailyOrderAvg" placeholder="日预估订单量">
                            <Option v-for="item in dailyOrderAvgList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Form>
                <div>
                    <Checkbox v-model="readAgree" class="register-check">
                        我已阅读并同意
                        《
                        <Button class="asinkingTerm" @click="modal.modalPrivacy=true">用户协议</Button>
                        》
                    </Checkbox>
                </div>
                <div class="submitApply">
                    <Button
                        type="primary"
                        @click="submitForm"
                    >
                    提交申请
                    </Button>
                </div>
                <Modal
                    class="read"
                    v-model="modal.modalPrivacy"
                    title="用户协议"
                    :z-index="9998"
                    :mask-closable="false"
                    width="52%"
                >
                    <div class="doc">
                        <h1 class="text-center">用户协议</h1>
                        <p class="font-bold no-indent">前部及导言</p>
                        <p><span class="font-bold">本《用户服务协议》（以下简称“本协议”）是用户（以下简称“您”）与江苏四海商舟电子商务有限公司</span> (以下称“我们”)之间关于用户使用Bizark Boss软件及服务所订立的协议。</p>
                        <p><span class="font-bold">为使用我们提供的Bizark Boss软件及服务，您应当阅读并遵守本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独条款，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。</span></p>
                        <p><span class="font-bold">本协议通过点击“阅读并同意”，即视为您已阅读并同意本协议项下的所有条款。除非您已阅读并同意本协议所有条款，否则您不得Bizark Boss软件软件的账户。 本协议自您点击“阅读并同意”时起生效。</span></p>
                        <!-- <p>本隐私及信息政策将帮助你了解以下内容：</p>
                        <ul class="one-level-indent">
                            <li>一．适用范围</li>
                            <li>二．我们可能收集的信息</li>
                            <li>三．我们如何存储您的信息</li>
                            <li>四．我们如何保护您的信息</li>
                            <li>五．我们如何使用您的信息</li>
                            <li>六．信息的分享和对外提供</li>
                            <li>七．如何访问和管理您的信息</li>
                            <li>八．敏感信息</li>
                            <li>九．未成年人保护</li>
                            <li>十．政策变更</li>
                            <li>十一．联系我们</li>
                            <li>十二．其他</li>
                        </ul> -->
                        <h2>一、协议的范围</h2>
                        <h3>1.1 协议适用主体范围</h3>
                        <div>
                            <p>
                                本协议是您与江苏四海商舟电子商务有限公司之间关于您注册、登录使用，以及使用Bizark Boss软件相关服务所订立的协议。
                            </p>
                        </div>
                        <h3>1.2 协议关系及冲突条款</h3>
                        <div>
                            <p>如果本协议与实际签订的合同存在矛盾或不一致的内容，以实际签订的合同为准。</p>
                            <p>未经事先书面许可，我们的直接竞争对手不可使用本软件及服务。此外，直接竞争对手也不能以监视服务的可用性、性能或功能为目的或出于任何其他基准建立或竞争目的使用本软件及服务。</p>
                            <p>本协议最后更新时间为2021年5月1日。我们可能不断发布关于本软件的相关协议、规则、规范等内容，前述内容一经发布，即为本协议不可分割的组成部分，与其构成统一整体，您同样应当遵守。</p>
                        </div>
                        <h2>二、关于本服务</h2>
                        <h3>2.1 本服务内容</h3>
                        <div>
                            <p>本服务内容是指Bizark Boss软件向跨境电商平台卖家(亚马逊商城的卖家、Wayfair卖家、Wlamart卖家等)以及代运营服务商或者其从业人员提供的ERP软件服务，这将有助于您或者您代表的某个实体公司及其附属机构在运营过程中做出商业决策。（以下简称“本服务”）。</p>
                        </div>
                        <h3>2.2 本服务形式</h3>
                        <div>
                            <p>您可能通过电脑、手机等终端以客户端、网页等形式使用本软件及服务，具体以我们提供的为准，我们会不断丰富您适用本软件及服务的终端、形式等。当您使用本软件及服务时，您应选择与您终端、系统等相匹配的本软件版本，否则无法正常使用本软件及服务。</p>
                            <p>其他服务，例如本软件的支持服务，仅在事先达成协议后作为附加服务提供。本软件可能但没有义务向您提供任何的支持服务，也没有义务签订此类附加服务的合同。</p>
                            <p>您可以创建自己的用户帐户以使用本软件。我们将通过您的帐户授予您购买的服务范围的使用权限。</p>
                        </div>
                        <h3>2.3 软件更新</h3>
                        <div>
                            <p>了改善用户体验、完善服务内容，我们将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</p>
                            <p class="font-bold">为了保证本软件及服务的安全性和功能的一致性，我们有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</p>
                            <p class="font-bold">本软件的部分功能取决于亚马逊通过API提供的数据以及通过其他方式收集的数据。我们只能处理和分析此类数据。因此，在某些情况下，我们可能会被迫减少本软件或某些工具的可用功能；并且，只要这种功能的减少是亚马逊对可用数据进行更改的结果我们有权按照上述方式进行处理。如果在上述情况下本软件功能的减少损害了您对使用本软件的兴趣，则您有权终止本软件的订购。</p>
                        </div>
                        <h2>三、您的义务</h2>
                        <h3>3.1 用户个人信息保护</h3>
                        <div>
                            <p>保护用户个人信息是我们的一项基本原则，我们将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可我们不会向第三方公开、透露用户个人信息。我们对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。</p>
                            <p class="font-bold">您在注册帐号或使用本服务的过程中，需要提供一些必要的信息，例如：为向您提供帐号注册服务或进行用户身份识别，需要您填写邮箱、手机号码等。若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
                            <p class="font-bold">本软件无法访问或我们提供的服务存在故障、缺陷，您在发现后应通过邮件、Q群、电话等方式立即向我们反馈。造成影响的，您应尽可能以文本形式描述，解释如何再现故障、缺陷或功能障碍。</p>
                            <p>我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
                            <p>未经您的同意，我们不会向其他任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。</p>
                        </div>
                        <h3>3.2 用户使用须知</h3>
                        <div>
                            <p>您在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：</p>
                            <ul class="list-style">
                                <li>•	发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；</li>
                                <li>•	发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；</li>
                                <li>•	恶意虚构事实、隐瞒真相以误导、欺骗他人；</li>
                                <li>•	发布、传送、传播广告信息及垃圾信息；</li>
                                <li>•	其他法律法规禁止的行为。</li>
                            </ul>
                            <p>您有责任自行备份存储在本服务中的数据。如果您的服务被终止，我们可以从服务器上永久地删除您的数据且不承担任何责任。服务终止后，我们没有义务向您返还数据。</p>
                        </div>
                        <h2>四、数据访问及数据管理</h2>
                        <div>
                            <p>您有义务按照本协议约定向我们提供履行服务所需的所有数据。本软件通过您的亚马逊帐户(“亚马逊帐户”)的授权以获取相关数据及报表，将明确并诚实地告知您需要访问的数据及其用途，<span class="font-bold">您必须确保我们被授予此目的所需的所有访问权限。根据亚马逊对个人身份信息保留政策要求，我们针对在您的买家订单发货之日起30天后自动删除您的买家个人身份信息，并且不做任何备份。</span></p>
                            <p>您提供的用于分析的数据不得违反法律规定或侵犯第三方的权利。我们提供的服务不得用于非法或第三方侵权目的。如果发生违规行为，我们可能会暂停提供即时生效的服务或阻止您访问本软件。</p>
                            <p>您授予我们使用数据所需的权利，以便根据本协议分析交付数据。</p>
                            <p class="font-bold">由于您所需的数据分析的性质，我们可能使用授权的亚马逊帐户来收集和分析与您没有直接关系的数据，例如与您未出售的产品有关的数据。您允许我们分析此类数据。</p>
                            <p>根据亚马逊及其他店铺的数据保护政策规定，我们必须为应用程序或服务创建、记录并遵守隐私以及数据处理策略，这些政策规定管理和保护信息资产时的适当行为和技术控制。我们必须保存能够访问PII的软件和实物资产(如计算机、移动设备)，并定期进行更新。应维护数据处理活动的记录，如特定数据字段及其所有PII信息的收集、处理、存储、使用、共享和处置方式，以建立责任和遵守条例。我们必须建立并遵守客户同意的隐私政策和数据访问权，纠正、删除或停止共享/处理其信息(如适用)或数据隐私条例所要求的信息。</p>
                            <p>我们有权每年定期对您使用或管理Bizark Boss软件涉及的数据分析、使用、传输等事宜进行监督及审查，如发现您违反本协议约定使用数据或其他损害第三方合法权益事宜的，我们有权中止为乙方提供服务，并要求您整改直至满足法律法规及我们的要求，如您未能整改的，我们有权终止为您提供服务。</p>
                            <p>在收到亚马逊或者其他销售平台通知并根据其要求删除亚马逊信息及其他关联信息，必须由我们自行立即（但必须在亚马逊的要求后不超过48小时之内）永久且安全地删除。我们还必须在亚马逊发出通知后的60天内永久安全地删除所有实时的（在线或网络可访问的）亚马逊信息实例。</p>
                        </div>
                        <h2>五、服务变更、中断与终止</h2>
                        <h3>5.1 在法律允许的范围内，如发生下列任何一种情形，我们有权不经通知而中断、中止或终止服务：</h3>
                        <div>
                            <ul class="list-style">
                                <li>•	受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</li>
                                <li>•	您或我们的电脑软件、系统、硬件和通信线路出现故障；</li>
                                <li>•	违反相关法律法规或本协议的约定；</li>
                                <li>•	根据法律规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；</li>
                                <li>•	出于安全的原因或其他必要的情形；</li>
                                <li>•	其他我们无法控制或合理预见的情形。</li>
                            </ul>
                        </div>
                        <h2>六、保证与免责声明</h2>
                        <h3>6.1 相互保证</h3>
                        <div>
                            <p>各方认可和保证：</p>
                            <ul>
                                <li>(1)  签署本协议具有法律效力;</li>
                                <li>(2)  不会向对方转移任何恶意代码(由其它方向保证方传输的恶意代码除外)。</li>
                            </ul>
                        </div>
                        <h3>6.2 免责声明</h3>
                        <div>
                            <ul class="font-bold">
                                <li>(1)  由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露。</li>
                                <li>(2)  任何黑客政击、计算机病毒侵入或发作、政府部门管制和其他不可抗力等造成的个人资料泄露、丢失、被盗用或被窜改等。</li>
                                <li>(3)  因与本软件或我们的网站链接的其它网站造成个人资料泄露及由此而导致的任何法律争议和后果。</li>
                            </ul>
                        </div>
                        <h2>七、保密约定</h2>
                        <h3>7.1 您与我们双方对本协议内容以及对本协议过程执行情况予以保密，不得向第三方披露。</h3>
                        <h3>7.2 您与我们双方互为保密资料的提供方和接受方，负有保密义务，承担保密责任。</h3>
                        <h3>7.3 甲乙双方中任何一方未经对方书面同意不得向第三方公开和披露任何保密资料或以其他方式使用保密资料。 </h3>
                        <h3>7.4 您与我们也须促使各自代表不向第三方公开或披露任何保密资料或以其它方式使用保密资料。除非披露、公开或利用保密资料是双方从事或开展合作项目工作在通常情况下应承担的义务（包括双方今后依法律或合同应承担的义务）适当所需的。</h3>
                        <h2>八、国际数据传输</h2>
                        <div>
                            <p class="font-bold">根据我们适用的法律和法规，在您所在国家/地区之外的任何地方，我们或我们的第三方运营机构将保留传输、处理和储存您的信息的权利。</p>
                        </div>
                        <h2>九、关于我们使用cookie条款</h2>
                        <div>
                            <p class="font-bold">Cookies 是细小的资料档（通常是数字与字母），网站存放于您的电脑或移动设备上的小型资料文件（通常是数字和字母）。 Cookies 将帮助该网站或另一个网站在您下次浏览时，对您的设备进行识别。网络信标或其他类似文件也具有同样功能。在本协议中，我们使用「cookies」一词来指称以此方式收集信息的所有文件。 Cookies 可实施很多不同的功能，比如让您在网页之间高效导航，保存您的偏好，以及全面改进您对网站的访问体验。本软件页面可能使用cookies，以便当您返回我们的网站时，本软件可以为您提供信息访问权限。</p>
                            <p class="font-bold">尽管对于Cookie的隐私含义一直存在争议，但是对于本软件的客户而言，重要的是要知道cookie不会读取您的硬盘驱动器，也不能使用cookie来泄露您未选择透露的关于您的新信息。本软件可能会使用cookie来记录您在我们网站上的活动。请注意，您的网络浏览器设置可能会进行调整，以限制或禁止该网站和其他网站放置Cookie。</p>
                        </div>
                        <h2>十、管辖与适用法律</h2>
                        <div>
                            <p>本协议适用中华人民共和国法律。</p>
                            <p>因本协议引起的或与本协议有关的任何争议，各方应友好协商解决；协商不成的，如果在一方向其他方送达要求开始协商的书面通知后六十天内未能通过协商解决争议，那么任何一方均可向南京仲裁委员会适用该会仲裁规则提起仲裁。当任何争议发生时以及在对任何争议进行仲裁时，除争议事项外，各方应继续行使各自在本《用户协议》项下的其他权利，履行各自在本《用户协议》项下的其他义务。</p>
                            <p>本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
                            <p>本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
                        </div>
                    </div>
                    <div slot="footer">
                        <Button
                            type="primary"
                            @click="agree('modalPrivacy')"
                        >
                            同意并继续
                        </Button>
                    </div>
                </Modal>
                <Modal
                    v-model="modal.tip"
                    title="提示"
                    :z-index="9998"
                    :mask-closable="false"
                >
                    <div>{{importTip}}</div>
                    <div slot="footer">
                        <Button
                            type="primary"
                            @click="makeSure"
                        >
                            确定
                        </Button>
                    </div>
                </Modal>
            </div>
        </div>
    </div>
</template>

<script>
import { HttpCheckIdVectorExists, HttpRegistCommit } from "@/service/port";
export default {
    data() {
        return {
            ohterText:"",
            ohterTip:false,
            importTip:"",
            formData: {
                userName:"",
                userLoginEmail:"",
                userLoginPhone:"",
                repassword:"",
                userPassword:"",
                companyName:"",
                companyAddress:"",
                contactName:"",
                contactTel:"",
                orgName:"",
                extraInfo:{
                    dailyOrderAvg:""
                },
            },
            readAgree:false,
            modal:{
                modalPrivacy:false,
                tip:false,
            },
            dailyOrderAvgList:[
                {
                    value:"0~100",
                    label:"0~100",
                },
                {
                    value:"100~500",
                    label:"100~500",
                },
                {
                    value:"500~1000",
                    label:"500~1000",
                },
                {
                    value:"1000+",
                    label:"1000+",
                },
            ]
        };
    },
    watch: {
    },
    created() {
    },
    computed: {
        rules() {
            return {
                userLoginEmail:[
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (
                                /^[a-z\d]+(\.[a-z\d]+)*@([\da-z](-[\da-z])?)+(\.{1,2}[a-z]+)+$/.test(
                                    value
                                )
                            ) {
                                callback();
                            } else {
                                callback(
                                    new Error(
                                        this.$t("global.common.email", {
                                            defaultValue: "请输入email格式",
                                        })
                                    )
                                );
                            }
                        },
                    },
                ],
                userPassword: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        validator: (rule, value = "", callback) => {
                            let tip;
                            if (
                                value.length < 8 ||
                                !(/[a-z]+/i.test(value) && /\d+/.test(value))
                            ) {
                                tip = this.$t("global.password.rule", {
                                    defaultValue:
                                        "必须包含数字字母,密码长度不能少于八位",
                                });
                            }
                            callback(tip ? new Error(tip) : undefined);
                        },
                    },
                ],
                repassword: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        validator: (rule, value = "", callback) => {
                            let tip;
                            if (
                                value.length < 8 ||
                                !(/[a-z]+/i.test(value) && /\d+/.test(value))
                            ) {
                                tip = this.$t("global.password.rule", {
                                    defaultValue:
                                        "必须包含数字字母,密码长度不能少于八位",
                                });
                            }
                            if (value !== this.formData.userPassword) {
                                tip = this.$t("global.password.same_password", {
                                    defaultValue: "请确认密码一致",
                                });
                            }
                            callback(tip ? new Error(tip) : undefined);
                        },
                    },
                ],
                userName: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
                userLoginPhone: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (
                                /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/.test(
                                    value
                                )
                            ) {
                                callback();
                            } else {
                                callback(
                                    new Error(
                                        this.$t("global.common.phone", {
                                            defaultValue: "请输入正确手机格式",
                                        })
                                    )
                                );
                            }
                        },
                    },
                ],
                companyName: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
                contactName: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
                contactTel: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (
                                /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/.test(
                                    value
                                )
                            ) {
                                callback();
                            } else {
                                callback(
                                    new Error(
                                        this.$t("global.common.phone", {
                                            defaultValue: "请输入正确手机格式",
                                        })
                                    )
                                );
                            }
                        },
                    },
                ],
                'extraInfo.dailyOrderAvg':[
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
            }
        }
    },
    methods: {
        backToLogin() {
            this.$router.push({ name: "login" });
        },
        agree(data){
            this.readAgree = true;
            this.modal[data] = false;
        },
        async submitForm(){
            const valid = await this.$refs["register"].validate();
            if (!valid) return;
            if(!this.readAgree){
                this.$VMessage.error("请先阅读并同意条款");
                return
            }
            console.log(this.formData)
            await HttpRegistCommit({
                userName:this.formData.userName,
                userLoginEmail:this.formData.userLoginEmail,
                userLoginPhone:this.formData.userLoginPhone,
                userPassword:this.formData.userPassword,
                companyName:this.formData.companyName,
                companyAddress:this.formData.companyAddress,
                contactName:this.formData.userName,
                contactTel:this.formData.userLoginPhone,
                orgName:this.formData.companyName,
                extraInfo:JSON.stringify(this.formData.extraInfo)
            }).then(res => {
                    this.importTip = "注册申请提交成功，待管理员审核......";
                    this.modal.tip = true;
                    this.formData.extraInfo = JSON.parse(this.formData.extraInfo);
                }, err => {
                    this.$VMessage.error(err.message);
                });
        },
        makeSure(){
            this.modal.tip = false;
        },
        async check(){
            if(!this.modal.tip && (this.formData.userLoginEmail || this.formData.userLoginPhone || this.formData.companyName)){
                var params={
                    orgName:"",
                    userLoginEmail:"",
                    userLoginPhone:"",
                    excludeId: 0
                }
                params.orgName = this.formData.companyName;
                params.userLoginEmail = this.formData.userLoginEmail;
                params.userLoginPhone = this.formData.userLoginPhone;
                await HttpCheckIdVectorExists(
                    params
                ).then(res => {
                    if(res.data.resultMessage.includes("已注册") || res.data.resultMessage.includes("已提交")){
                        this.importTip = res.data.resultMessage;
                        this.modal.tip = true;
                        this.ohterTip = false;
                    }else{
                        this.ohterText = res.data.resultMessage;
                        this.ohterTip = true
                    }
                }, err => {
                    this.$VMessage.error(err.message);
                });
            }
        }
    },
};
</script>
